import { Script } from 'gatsby';
import React from 'react';

const DonationForm = () => {
  return (
    <>
      <div
        id='fr-placed-form-container-18677'
        style={{ minHeight: `816px`, minWidth: `345px`, marginTop: '90px' }}
      ></div>

      <Script id='donationformscript'>{`
        (function(f,u,n,r,a,i,s,e){var data={window:window,document:document,tag:"script",data:"funraise",orgId:f,uri:u,common:n,client:r,script:a};var scripts;var funraiseScript;data.window[data.data]=data.window[data.data]||[];if(data.window[data.data].scriptIsLoading||data.window[data.data].scriptIsLoaded)return;data.window[data.data].loading=true;data.window[data.data].push("init",data);scripts=data.document.getElementsByTagName(data.tag)[0];funraiseScript=data.document.createElement(data.tag);funraiseScript.async=true;funraiseScript.src=data.uri+data.common+data.script+"?orgId="+data.orgId;scripts.parentNode.insertBefore(funraiseScript,scripts)})('9d1b91e4-a945-461b-9aa4-ccd834661c36','https://assets.funraise.io','/widget/common/2.0','/widget/client','/inject-form.js');
    `}</Script>

      <Script id='donationformconfiguration'>{`window.funraise.push('create', { form: 18677 }, {
        selector: '#fr-placed-form-container-18677',
        type: 'grow_contained',
    });`}</Script>

      <Script id='donationpopup'>
        {`      
          window.funraise.push('create', { form: 18677 });  
        `}
      </Script>
      <Script id='donationevent'>
        {`
          window.funraise.push('onSuccess', {form: 18677 }, function(donor, donation) {
            gtag("event", "purchase", {
              transaction_id: donation.transactionId,
              value: donation.amount,
              currency: donation.currency.name,
              items: [
                {
                  item_name: donation.formName,
                  item_category: donation.frequency
                }
              ]
            });
            console.log("Donor: " + donor);
            window.location.href = 'https://worldsavvy.org/thank-you?firstName=' + donor.firstName;
          });
        `}
      </Script>
    </>
  );
};

export default DonationForm;
